import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import useI18n from '@i18n/useI18n'

interface Props {
  score?: number
}

const ConformityCard = ({ score }: Props) => {
  const i18n = useI18n()

  return (
    <Card>
      <ConformityText>{i18n.t('components.conformity.rate')}</ConformityText>
      <Conformity>{score !== undefined ? `${Math.floor(score)}%` : i18n.t('errors.NC')}</Conformity>
    </Card>
  )
}

export default ConformityCard

const Card = styled(View)`
  background-color: ${(props) => props.theme.colors.alertButtonLight};
  border: 0 solid ${(props) => props.theme.colors.accent};
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-right-width: 1px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 8px 12px;
  flex-direction: row;
  align-items: center;
`

const ConformityText = styled(Text)`
  ${(props) => props.theme.fonts.Caption1};
  color: ${(props) => props.theme.colors.accent};
  margin-right: ${(props) => (props.theme.breakpoint === 'phone' ? 4 : 12)}px;
  max-width: 75px;
`

const Conformity = styled(Text)`
  ${(props) => props.theme.fonts.Subheadline};
  color: ${(props) => props.theme.colors.accent};
`
